import axios from 'axios';

const downloadAsFiles = (params: string): any => {
    // https://api-website-v1-dev.fusemachines.com/api/v1/csv?formTypeId=3
    return axios.get(`csv?${params}`);
};

export default downloadAsFiles;